export default __webpack_public_path__ + "static/media/A0005.f889ec01.png";